"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchGetMock = exports.fetchMock = exports.parseWith = exports.fetchParams = exports.fetchPatch = exports.fetchPut = exports.fetchDelete = exports.fetchPost = exports.fetchGet = exports.fetchHead = exports.postJSON = exports.fetchJSON = exports.fetchWrapper = exports.composeFetchHandlers = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.number.constructor");

require("whatwg-fetch");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//this is for ie11

/** Fetch Methods - helper utilities */
var defaultFetchHandlers = {
  'HEAD': function HEAD(res) {
    return res;
  },
  'GET': function GET(res) {
    return res;
  },
  'PUT': function PUT(res) {
    return res;
  },
  'POST': function POST(res) {
    return res;
  },
  'PATCH': function PATCH(res) {
    return res;
  },
  'DELETE': function DELETE(res) {
    return res;
  }
};

var composedFetchHandlers = _objectSpread({}, defaultFetchHandlers);
/**
 * Accept a new set of global fetch handlers.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  [handlers={}] [description]
 * @return {[type]}               [description]
 */


var composeFetchHandlers = function composeFetchHandlers() {
  var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  composedFetchHandlers = _objectSpread({}, defaultFetchHandlers, handlers);
  return composedFetchHandlers;
};
/**
 *  Lowest base form of fetch, provides timeout option.
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param  {string}  url      the url to call
 * @param  {object}  options  options to pass through with the call.
 * @return {Promise}          Returns a promise that will be resolved after timeout.
 */


exports.composeFetchHandlers = composeFetchHandlers;

var fetchWrapper = function fetchWrapper(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  //Make suer we have our ajax request header sent for the api responses to make sure they know we are ffom an ajax requrest
  options.headers = options.headers || {};
  options.headers['X-Requested-With'] = 'XMLHttpRequest';
  var request = fetch(url, options);

  if (typeof options.timeout === 'undefined' || Number(options.timeout) === 0) {
    return request;
  } else {
    return Promise.race([timeout(options.timeout), request]);
  }
};
/**
 *  Fetch expecting a json response.
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param  {string}  url     the url to call
 * @param  {object}  options options to pass through with the call.
 * @return {Promise}         Returns a promise that will be resolved after timeout.
 */


exports.fetchWrapper = fetchWrapper;

var fetchJSON = function fetchJSON(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaults = {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  };

  var settings = _objectSpread({}, defaults, options);

  var handleResponseComposed = composedFetchHandlers[settings.method] || function (res) {
    return res;
  };

  return fetchWrapper(url, settings).then(handleResponseComposed, handleNetworkError).then(handleResponseJson);
};
/**
 *  Do a Post expecting a json response.
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param  {string}  url     the url to call
 * @param  {mixed}   data    the data to post through
 * @param  {object}  options options to pass through with the call.
 * @return {Promise}         Returns a promise that will be resolved after timeout.
 */


exports.fetchJSON = fetchJSON;

var postJSON = function postJSON(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaults = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };

  var settings = _objectSpread({}, defaults, options);

  var handleResponseComposed = composedFetchHandlers[settings.method] || function (res) {
    return res;
  };

  return fetchWrapper(url, settings).then(handleResponseComposed, handleNetworkError).then(handleResponseJson);
};
/**
 * Handles the json format response
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param {mixed} response The response to try to parse as JSON
 * @returns {Promise} The fetch promise result
 * @throws error
 */


exports.postJSON = postJSON;

var handleResponseJson = function handleResponseJson(response) {
  if (response.ok) {
    return response.json();
  } else {
    return response.json().then(function (error) {
      throw error;
    });
  }
};
/**
 * Handles network error and throws error.
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param {object} error The error object to handle.
 * @returns {Promise} The fetch promise result
 */


var handleNetworkError = function handleNetworkError(error) {
  throw {
    msg: error.message
  };
};
/**
 * Handles the timeout functionality of a fetch call
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param {number} value The request timeout to use
 * @returns {Promise} The fetch promise result
 */


var timeout = function timeout(value) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error('Sorry, request timed out.'));
    }, value);
  });
};
/**
 * fetchHead does a get to a specific url including the credentials option
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param {string} url     The URL we want to fetch
 * @param {object} options Any additonal options for this request
 * @returns {Promise} The fetch promise result
 */


var fetchHead = function fetchHead(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaults = {
    method: 'HEAD',
    credentials: 'include',
    headers: {
      'Accept': 'application/json'
    }
  };
  return fetchWrapper(url, _objectSpread({}, defaults, options)).then(function (response) {
    return response;
  }, handleNetworkError);
};
/**
 * fetchGet does a get to a specific url including the credentials option
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param {string} url     The URL we want to fetch
 * @param {object} options Any additional options for this request.
 * @returns {Promise} The fetch promise result
 */


exports.fetchHead = fetchHead;

var fetchGet = function fetchGet(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetchJSON(url, _objectSpread({
    method: 'GET',
    credentials: 'include'
  }, options));
};
/**
 * High level AJAX POST method.
 *
 * Handles timeouts, adds credentials to requests, etc.
 * Expects to be JSON
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  url          [description]
 * @param  {Object}  data         [description]
 * @param  {Object}  options	  Fetch options.
 *
 * @return {Promise}              Returns the fetch promise.
 */


exports.fetchGet = fetchGet;

var fetchPost = function fetchPost(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return postJSON(url, data, _objectSpread({
    method: 'POST',
    credentials: 'include'
  }, options));
};
/**
 * fetchDelete does a delete to a specific url including the credentials option
 *
 * @author Sam Sehnert <sam@customd.com>
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @param {string} url     The URL we want to fetch
 * @param {object} options Any additional options for this request.
 * @returns {Promise} The fetch promise result
 */


exports.fetchPost = fetchPost;

var fetchDelete = function fetchDelete(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetchJSON(url, _objectSpread({
    method: 'DELETE',
    credentials: 'include'
  }, options));
};
/**
 * High level AJAX PUT method.
 *
 * Handles timeouts, adds credentials to requests, etc.
 * Expects to be JSON
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  url          [description]
 * @param  {Object}  data         [description]
 * @param  {Object}  options	  Fetch options.
 *
 * @return {Promise}              Returns the fetch promise.
 */


exports.fetchDelete = fetchDelete;

var fetchPut = function fetchPut(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return postJSON(url, data, _objectSpread({
    method: 'PUT',
    credentials: 'include'
  }, options));
};
/**
 * High level AJAX PATCH method.
 *
 * Handles timeouts, adds credentials to requests, etc.
 * Expects to be JSON
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  url          [description]
 * @param  {Object}  data         [description]
 * @param  {Object}  options	  Fetch options.
 *
 * @return {Promise}              Returns the fetch promise.
 */


exports.fetchPut = fetchPut;

var fetchPatch = function fetchPatch(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return postJSON(url, data, _objectSpread({
    method: 'PATCH',
    credentials: 'include'
  }, options));
};
/**
 * Converts an object into url parameters
 *
 * E.g., given input object;
 *
 *   {
 *     "user_id" : 12,
 *     "name" : "^john"
 * 	   "age"  : {min: 10, max: 18}
 * 	   "gender" : ['male','female']
 *   }
 *
 * This method would output;
 *
 *   "user_id=12&name=%5Ejohn&age[min]=10&age[max]=15&gender=male||female"
 *
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  params     Key -> value for parameter props.
 * @param  {string} prefix		prefix for the key if is an array input
 * @return {String}             The url parameters.
 */


exports.fetchPatch = fetchPatch;

var fetchParams = function fetchParams(params, prefix) {
  var getStr = [],
      param;

  for (param in params) {
    if (params.hasOwnProperty(param)) {
      var key = prefix ? prefix + '[' + param + ']' : param,
          value = params[param];

      if (value !== null && value !== undefined) {
        //If is an array of strings / numbers if there is a single object (that is not null (typeof null is 'object)) then
        // seperate as per normal - else use the object filter.
        if (Array.isArray(value) && value.filter(function (val) {
          return _typeof(val) === 'object' && val !== null;
        }).length === 0) {
          getStr.push(encodeURIComponent(key) + '=' + encodeURIComponent(value.join('||')));
        } else {
          getStr.push(_typeof(value) === 'object' ? fetchParams(value, key) : encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
      }
    }
  }

  return getStr.join('&');
};
/**
 * converts to allow you to pass a with to the url api endpoint
 *
 * @param {string/array} withParam string or array of withs
 * @return {string} the with string seperated by ,
 */


exports.fetchParams = fetchParams;

var parseWith = function parseWith(withParam) {
  if (typeof withParam !== 'string' && typeof withParam !== 'undefined') {
    return withParam.join(',');
  }

  return withParam;
};
/**
 * Easily mock up an API response to a fetch request.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {object}  data     The data to resolve the promise with.
 * @param  {number}  timeout  Promise will resolve after timeout (in ms). Defaults to 500 ms.
 * @return {Promise}          Returns a promise that will be resolved after timeout.
 */


exports.parseWith = parseWith;

var fetchMock = function fetchMock(data) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  return new Promise(function (resolve, reject) {
    var response = _objectSpread({
      result: 'success'
    }, data);

    setTimeout(function () {
      return resolve(response);
    }, timeout);
  });
};
/**
 * DEPRECATED: Easily mock up an API response to a fetch request.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {object}  data     The data to resolve the promise with.
 * @param  {number}  timeout  Promise will resolve after timeout (in ms). Defaults to 500 ms.
 * @return {Promise}          Returns a promise that will be resolved after timeout.
 */


exports.fetchMock = fetchMock;

var fetchGetMock = function fetchGetMock(data) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  console.warn('fetchGetMock is deprecated, please use fetchMock instead.');
  return fetchMock(data, timeout);
};
/**
 * FetchApi - our default Return object is the base class for an Api Endpoint
 *
 * @export
 * @constructor FetchApi
 * @author Craig Smith <craig.smith@customd.com>
 *
 * @sample
 ```
  class XxxModel extends FetchApi {
   const api_url = Site.api_url + "xxx";
  }
  const Xxx = new xxxModel
  export default Xxx```
 *
 * The above will give you access to the endoints listed within the class
 */


exports.fetchGetMock = fetchGetMock;

var FetchApi = function FetchApi() {
  var _this = this;

  _classCallCheck(this, FetchApi);

  _defineProperty(this, "get", function (id) {
    var withs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var params = fetchParams({
      id: id,
      with: withs
    });
    return fetchGet("".concat(_this.api_url, "?").concat(params));
  });

  _defineProperty(this, "getWhere", function (where, sort, limit, offset) {
    var params = fetchParams(_objectSpread({}, where, {
      sort: sort,
      limit: limit,
      offset: offset
    }));
    return fetchGet("".concat(_this.api_url, "?").concat(params));
  });

  _defineProperty(this, "getWith", function (withItems, where, sort, limit, offset) {
    var withParam = parseWith(withItems);
    var params = fetchParams(_objectSpread({}, where, {
      sort: sort,
      limit: limit,
      offset: offset,
      with: withParam
    }));
    return fetchGet("".concat(_this.api_url, "?").concat(params));
  });

  _defineProperty(this, "post", function (data) {
    return fetchPost(_this.api_url, data);
  });

  _defineProperty(this, "postWith", function (withItems, data) {
    var withParam = parseWith(withItems);
    var params = fetchParams({
      with: withParam
    });
    return fetchPost("".concat(_this.api_url, "?").concat(params), data);
  });

  _defineProperty(this, "put", function (data) {
    return fetchPut(_this.api_url, data);
  });

  _defineProperty(this, "putWith", function (withItems, data) {
    var withParam = parseWith(withItems);
    var params = fetchParams({
      with: withParam
    });
    return fetchPut("".concat(_this.api_url, "?").concat(params), data);
  });

  _defineProperty(this, "patch", function (data) {
    return fetchPatch(_this.api_url, data);
  });

  _defineProperty(this, "patchWith", function (withItems, data) {
    var withParam = parseWith(withItems);
    var params = fetchParams({
      with: withParam
    });
    return fetchPatch("".concat(_this.api_url, "?").concat(params), data);
  });

  _defineProperty(this, "delete", function (id) {
    return fetchDelete("".concat(_this.api_url, "?id=").concat(id));
  });

  _defineProperty(this, "deleteWhere", function (where, sort, limit, offset) {
    var params = fetchParams(_objectSpread({}, where, {
      sort: sort,
      limit: limit,
      offset: offset
    }));
    return fetchDelete("".concat(_this.api_url, "?").concat(params));
  });

  _defineProperty(this, "getMock", function (data) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    return fetchMock(data, timeout);
  });
};

exports.default = FetchApi;